import React, { useState } from 'react';
// @ts-ignore
import styles from "./PasswordField.module.scss";

interface Props {
	name: string;
	isRequired?: boolean;
	placeholder?: string;
	value?: string;
	onChange?: (value: string) => void;
}

const PasswordField: React.FC<Props> = ({name, isRequired, value, onChange, placeholder}) => {
	const [isHidden, setIsHidden] = useState(true);
	return (
		<div className={styles.wrapper}>
			<input type={isHidden ? 'password' : 'text'} name={name} required={isRequired} defaultValue={value} onChange={() => onChange} placeholder={placeholder} className={styles.input}/>
			<img src='/dist/patientV3/icons/eye-solid.svg' alt='eye' onClick={() => setIsHidden(prev => !prev)}/>
		</div>
	)
}

export default PasswordField;